import "./ShopCollection.module.css";
import Header from "@/reusable_sections/Header";
import HeroPequeño from "./sections/HeroPequeño";
import Filtros from "./sections/Filtros";
import ProductGrid from "./sections/ProductGrid";
import NavegacionDePaginacion from "./sections/NavegacionDePaginacion";
import Footer from "@/reusable_sections/Footer";
export default function ShopCollectionPage() {
  return <div>
      <Header />
      <HeroPequeño />
      <Filtros />
      <ProductGrid />
      <NavegacionDePaginacion />
      <Footer />
    </div>;
}